import React, { useMemo } from "react";
import TableStyle from "components/Content/Table/TableStyle.module.css";
import CurrencyFormatter from "components/Formatter/CurrencyFormatter";
import { Box } from "@mui/material";

export default function AccountingBalance ({accountType, accountingBalance}) {

    const outstandingBalances = useMemo(() => {
        let balances = [];
    
        Object.keys(accountingBalance).map((item, index) => {    
          if (typeof accountingBalance[item] === "string" && item.indexOf("aging") > -1) {
            balances.push({
              index: item[5],
              header: accountingBalance[item],
            });
          }
        });

        balances.forEach(b => {
            b.value = accountingBalance[`aging${b.index}`];
        });

        return balances;
    }, [accountingBalance])

    return (
        <Box className={TableStyle.tableWrapper}>
            <Box className="row" sx={{ fontSize: "14px" }}>
                <Box className="col-xl-3 col-6 text-start">
                    <strong>{accountingBalance.unpaidInvoice}</strong> {accountType} invoice awaiting payment
                    {accountingBalance.prepay ?
                    <>
                        <Box className="row text-end">
                            <Box className="col-7">
                                Prefund Average Amount:
                            </Box>
                            <Box className="col-5">
                                <strong><CurrencyFormatter value={accountingBalance.prePayMinimum} /></strong>
                            </Box>
                        </Box>
                        <Box className="row text-end">
                            <Box className="col-7">
                                Current Balance:
                            </Box>
                            <Box className="col-5">
                                <strong><CurrencyFormatter value={accountingBalance.remainingCredit} /></strong>
                            </Box>
                        </Box>
                        <Box className="row text-end">
                            <Box className="col-7">
                                Prefund Amount Difference:
                            </Box>
                            <Box className="col-5">
                                <strong><CurrencyFormatter value={accountingBalance.remainingCredit - accountingBalance.prePayMinimum} /></strong>
                            </Box>
                        </Box>
                    </> : null}
                </Box>
                <Box className="col-xl-3 col-6 order-xl-2 text-end text-wrap">
                    <strong>{accountingBalance.displayAbbv}</strong> {accountType} Outstanding invoice balance <strong><CurrencyFormatter value={accountingBalance.amountDue} /></strong>
                </Box>
                <Box className="col-xl-6 col-12 order-xl-1 mt-2 mt-xl-0 table-responsive" sx={{ fontSize: "12px" }}>
                    <table className="table table-bordered table-sm text-center">
                        <thead>
                            <tr>
                                {outstandingBalances.map((ob,i) => (
                                    <th key={i} scope="col">
                                        {ob.header}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                {outstandingBalances.map((ob,i) => (
                                    <td key={i} scope="col">
                                        <CurrencyFormatter value={ob.value} />
                                    </td>
                                ))}
                            </tr>
                        </tbody>
                    </table>
                </Box>
            </Box>
        </Box>
      )
}